import { altOf, assetUrl } from "@/lib/content";
import { StockBadge } from "@/components/Pending";

export function srcSetOf(img, key = "variants") {
  const entries = Object.entries(img[key] || {});
  return entries.length ? entries.map(([w, src]) => `${assetUrl(src)} ${w}w`).join(", ") : undefined;
}

export default function Photo({ img, sizes = "100vw", eager = false, className = "", imgClassName = "", isPreview, badgeClass = "top-3 left-3" }) {
  const pos = { "--pos": img.position || "50% 50%", "--pos-m": img.position_mobile || img.position || "50% 50%" };
  return (
    <div className={`${className.includes("absolute") ? "" : "relative"} overflow-hidden ${className}`}>
      <picture>
        {img.avif && <source type="image/avif" srcSet={srcSetOf(img, "avif")} sizes={sizes} />}
        <img
          src={assetUrl(img.src)}
          srcSet={srcSetOf(img)}
          sizes={sizes}
          width={img.width}
          height={img.height}
          alt={altOf(img, isPreview)}
          loading={eager ? "eager" : "lazy"}
          fetchPriority={eager ? "high" : "auto"}
          decoding={eager ? "sync" : "async"}
          style={pos}
          className={`h-full w-full object-cover object-[var(--pos-m)] md:object-[var(--pos)] ${imgClassName}`}
        />
      </picture>
      {isPreview && img.stock && <StockBadge className={`absolute ${badgeClass}`} />}
    </div>
  );
}
